<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <b-field label="示意圖(各館次首頁類別選單下方廣告)">
          <p class="control">
            <a
              :href="helpImageUrl('各館次首頁類別選單下方廣告.png')"
              @click.prevent="
                onClickImage(helpImageUrl('各館次首頁類別選單下方廣告.png'))
              "
            >
              <img
                :src="helpImageUrl('各館次首頁類別選單下方廣告.png')"
                alt="各館次首頁類別選單下方廣告"
                width="256"
              />
            </a>
          </p>
        </b-field>

        <hr />

        <editor
          ref="top_ad_editor"
          v-model="form.top_ad"
          :area="catalog.image_path"
        ></editor>

        <b-field>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            :style="{ width: '100%' }"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>
  </section>
</template>

<script>
import { CATALOG_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import Editor from '@/components/editors/Editor4'
import { maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'TopAdForm',
  components: { Editor },

  props: {
    catalog: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,

      form: this.extractFormValues(this.catalog),

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      top_ad: { maxLength: maxLength(50000) }
    }
  },
  watch: {
    catalog(newCatalog) {
      this.form = this.extractFormValues(newCatalog)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        top_ad: data.top_ad || ''
      }
    },
    async onSend() {
      this.form.top_ad = this.$refs.top_ad_editor.getData()

      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${CATALOG_API}/${this.catalog.catalog_no}/top-ad`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)

        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    }
  }
}
</script>
